import { useState } from "react";

import BookmarkIcon from "components/actions/Bookmark";
import { SHOW_ON_HOVER } from "lib/core_components/ShowOnHover";
import { Opportunity } from "lib/generated/app-service-gql/graphql";
import { TrackingProvider } from "lib/tracking";
import { SaveSupplierButton } from "./lists/SaveSupplierButton";
import { SaveToButtonNoDrawer } from "./SaveToButton";
import { SaveToDrawer } from "./SaveToDrawer";
import { SharedSaveProps } from "./types";

type DisplayType = "bookmark" | "button";

type InRowSaveToButtonProps = SharedSaveProps & {
  displayType: DisplayType;
  isSaved?: boolean;
  savedCount?: number;
  entityName?: string; // Only used for suppliers currently
  opportunities?: Pick<Opportunity, "id">[];
};

export function InRowSaveToButton({
  displayType,
  isSaved = false,
  savedCount,
  entityName,
  opportunities,
  ...rest
}: InRowSaveToButtonProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const button =
    rest.entityType === "supplier" ? (
      // TODO: This is a temporary solution to ensure the supplier button works
      <SaveSupplierButton
        supplierGuid={rest.entityIds[0]}
        supplierName={entityName}
        onShowDrawer={() => setIsDrawerOpen(true)}
      />
    ) : (
      <SaveToButtonNoDrawer
        onShowDrawer={() => setIsDrawerOpen(true)}
        {...rest}
        opportunities={opportunities}
        savedCount={savedCount}
      />
    );
  return (
    <TrackingProvider data={{ "Context source": "In-row" }}>
      {isSaved && displayType === "bookmark" && <BookmarkIcon colour="blue" filled />}
      {isSaved && displayType === "button" && button}
      {!isSaved && <span className={SHOW_ON_HOVER}>{button}</span>}
      <SaveToDrawer
        {...rest}
        isOpen={isDrawerOpen}
        onOpenChange={(open) => setIsDrawerOpen(open)}
        savedCount={savedCount}
      />
    </TrackingProvider>
  );
}
